import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success(t("welcome_back"));
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("error_generic"));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="pt-28 pb-20 max-w-md mx-auto px-6">
      <div className="overline text-[#143122]">{t("login")}</div>
      <h1 className="mt-2 font-serif-display text-4xl text-[#143122]">{t("welcome_back")}</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">{t("email")}</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="kav-input" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">{t("password")}</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="kav-input" />
        </div>
        <button data-testid="login-submit" disabled={busy} type="submit" className="kav-btn-primary w-full justify-center">
          {busy ? "..." : t("login")}
        </button>
      </form>
      <p className="mt-6 text-sm text-[#1A1F1C]/70">
        {t("no_account")} <Link to="/register" className="text-[#143122] underline">{t("signup")}</Link>
      </p>
    </div>
  );
}
